export default "__VITE_ASSET__6d63a208__"